import React from "react";
import classNames from "classnames";
import { useMeet } from "util/useMeet";
import { useKnownLiftingOrder } from "util/useKnownLiftingOrder";
import take from "lodash/take";
import { usePlatform } from "util/usePlatform";
import { useCurrentAttempt } from "util/useCurrentAttempt";
import capitalize from "lodash/capitalize";

const NextOverlay = ({ platformId }: { platformId: string }) => {
  const meet = useMeet();
  const platform = usePlatform(platformId);
  const lifterOrder = useKnownLiftingOrder(platformId);
  const currentAttempt = useCurrentAttempt(platformId);

  const nextFive = take(
    lifterOrder.filter((a) => a.attemptId !== currentAttempt._id),
    5
  );

  if (!platform || !meet) {
    return null;
  }

  return (
    <div className="live-feed-next">
      <div className="live-feed-next-platform-name">{platform.name}</div>

      {nextFive.map((attempt) => {
        const lifterName = attempt.lifter.name || "";
        const liftName = capitalize(attempt.attempt.liftName || "");
        const attemptNumber = attempt.attempt.attemptNumber || "";
        const weight = attempt.attempt.weight || "";

        return (
          <div className="live-feed-next-row">
            <div></div>
            <div
              key={attempt.attemptId}
              className={classNames("live-feed-next-lifter", {
                "long-name": lifterName.length > 18,
                "really-long-name": lifterName.length > 21,
              })}
            >
              {lifterName}
            </div>
            <div className="live-feed-next-lift">
              {liftName} {attemptNumber}
            </div>
            <div className="live-feed-next-weight">
              {weight}
              {meet.units}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default NextOverlay;
